module.exports = __webpack_public_path__ + "img/b_circle.9a5e268a.svg";